export default {"src":"/_next/static/media/br-icon.8b1c4d0e.svg","height":22,"width":30};